import { render, staticRenderFns } from "./bid_check_config_list.vue?vue&type=template&id=2cd6f4ca&scoped=true"
import script from "./bid_check_config_list.vue?vue&type=script&lang=js"
export * from "./bid_check_config_list.vue?vue&type=script&lang=js"
import style0 from "./bid_check_config_list.vue?vue&type=style&index=0&id=2cd6f4ca&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd6f4ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2cd6f4ca')) {
      api.createRecord('2cd6f4ca', component.options)
    } else {
      api.reload('2cd6f4ca', component.options)
    }
    module.hot.accept("./bid_check_config_list.vue?vue&type=template&id=2cd6f4ca&scoped=true", function () {
      api.rerender('2cd6f4ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/customform/bid_check_config_list.vue"
export default component.exports